import React from "react";
import { container_classname } from "./constants";
import CTAButtons from "./CTAButtons";

interface CTACardProps {
    title: string;
    description: string;
    primaryButtonText?: string;
    primaryButtonUrl?: string;
}

const CTACard: React.FC<CTACardProps> = ({ title, description, primaryButtonText = "Book a Demo", primaryButtonUrl = "/demo" }) => {
    return (
        <div className={`${container_classname}  my-16`}>
            <div
                className="flex flex-col-reverse lg:flex-row lg:items-center justify-between gap-6 py-8 px-6 rounded-lg"
                style={{
                    background: "linear-gradient(92.69deg, #002DB5 -0.01%, #001754 100.83%)",
                    boxShadow: "0px 24px 48px -12px rgba(16, 24, 40, 0.18)",
                }}
            >
                <img
                    src="https://assets.gallabox.com/gb-home/compare/female-with-yellow-shirt-and-whatsapp-logo.png"
                    alt={"Female with yellow shirt and WhatsApp logo"}
                    width={250}
                    height={250}
                    className="relative -bottom-8 object-cover mx-auto"
                />
                <div className="text-white">
                    <p className="md:text-4xl text-3xl font-semibold font-inter">{title}</p>
                    <p className="text-sm md:text-base font-inter text-white mt-6 mb-8">{description}</p>
                    <CTAButtons
                        primaryButtonText={primaryButtonText}
                        variant="secondary-light"
                        urlLink={primaryButtonUrl}
                        style={{ border: "none", background: "linear-gradient(95.02deg, #FFFFFF 61.29%, #A1B8FF 100.79%)" }}
                    />
                </div>
            </div>
        </div>
    );
};

export default CTACard;
